export default "__VITE_PUBLIC_ASSET__db0e1624__"